import appConfig from '../../appConfig';

const voltran = require('/home/node/app/node_modules/voltranjs/src/index');

import React, { useEffect, useState, Suspense } from 'react';
import ROUTE_PATHS from '../../routes/routeConstants';
import MobileMenu from './MobileMenu/MobileMenu';
import LoyaltyService from 'Service/LoyaltyService';
import Skeleton from '@cosmos/skeleton';
import { trackAccountMenuClicked } from './trackEvents';
import { getBase64FromUrl } from 'Utils/helper';

const WebMenu = React.lazy(() => import('./WebMenu/WebMenu'));

const TouchPointSkeleton = () => {
  return (
    <div style={{ padding: 16, maxWidth: 328, width: '100%' }}>
      <Skeleton width="100%" height="20px" radius="10px" style={{ marginBottom: 20 }} />
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 10 }}>
        <Skeleton width="100%" height="40px" radius="10px" />
      </div>
    </div>
  );
};

const AccountMenuLoyaltyTouchPoint = ({ initialState: { location } }) => {
  const [isMobile, setMobile] = useState(false);
  const [touchpointData, setTouchpointData] = useState(null);

  const fetchMenuInfo = async userId => {
    const params = {
      headers: {
        'user-id': userId
      }
    };
    const {
      data: { result }
    } = await LoyaltyService.getAccountMenuLoyaltyHeaderData(params);
    if (result) {
      const b64List = await Promise.allSettled(
        result.animations.map(item => getBase64FromUrl(item.icon))
      );

      setTouchpointData({
        ...result,
        animations: result.animations.map((item, index) => {
          return { ...item, b64: b64List[index]?.value };
        })
      });
    }
  };

  useEffect(() => {
    setMobile(location?.isMobile?.toString() === 'true');
    fetchMenuInfo(location?.userId);
  }, [location]);

  const handleClick = async () => {
    await trackAccountMenuClicked(window?.loyaltyInfo?.statusText);
    if (window?.loyaltyInfo?.isPremium) {
      window.location.href = appConfig.loyaltyUrl;
    } else {
      window?.OneClickFullFillment({
        source: 'account'
      });
    }
  };

  if (!touchpointData) return <TouchPointSkeleton />;

  // TODO: Mobile will be created
  if (isMobile && false) {
    <MobileMenu {...touchpointData} onClick={handleClick} />;
  }
  return (
    <>
      <Suspense fallback={<TouchPointSkeleton />}>
        <WebMenu {...touchpointData} onClick={handleClick} />
      </Suspense>
    </>
  );
};

const component = voltran.default.withBaseComponent(
  AccountMenuLoyaltyTouchPoint,
  ROUTE_PATHS.ACCOUNT_LOYALTY_TOUCHPOINT
);

component.services = [];

export default component;
